import { useQuery } from '@tanstack/react-query';

import { callProfileDetails } from './request';

export const PROFILE_DETAILS_QUERY_KEY = 'PROFILE_DETAILS_QUERY';

// This hook accepts `eid` so that it is not tied to the
// current active user. This let's us use this query
// for all Yat Pages.
export function useProfileDetails(eid?: string | null) {
    return useQuery({
        queryKey: [PROFILE_DETAILS_QUERY_KEY, eid],
        queryFn: ({ signal }) =>
            callProfileDetails({
                settings: { signal },
                variables: {
                    primaryYat: eid ?? '',
                },
            }),
        enabled: Boolean(eid),
        staleTime: Infinity,
    });
}
